module.exports = __webpack_public_path__ + "static/media/header.34481f3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/About/img/header.jpg
// module id = 261
// module chunks = 0